export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6277.137989d5.jpg";